import { combineReducers } from "redux";
import { routerReducer } from 'react-router-redux'

import Global from '../components/global/reducer';
import Registration from '../components/registration/reducer';
import User from '../components/user/reducer';
import Listing from '../components/dashboard/listing/reducer';
import BrowseListings from '../components/listings/reducer';
import Dashboard from '../components/dashboard/reducer';
import Booking from '../components/dashboard/bookings/reducer';
import Search from '../components/search/reducer';
import Admin from '../components/admin/reducer';
import DestinationSuggestions from '../components/destination-autosuggest/reducer';

// main reducers
export const reducers = combineReducers({
  routing: routerReducer,
  Global: Global,
  Registration: Registration,
  User: User,
  Listing: Listing,
  BrowseListings: BrowseListings,
  Dashboard: Dashboard,
  Booking: Booking,
  Search: Search,
  Admin: Admin,
  DestinationSuggestions: DestinationSuggestions
});
